import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1aa09453"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Download Records", -1);
});

var _hoisted_4 = {
  class: "search-input"
};
var _hoisted_5 = ["innerHTML"];
import RiscernTable from '@/components/RiscernTable/index.vue';
import { ref } from 'vue';
import { apiReportRecordList } from '@/api/information';
import { headers } from './data';
import { useRoute } from 'vue-router';
import { txtFileDownload } from '@/utils/download-file';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var keywords = ref('');
    var subBtnLoading = ref(false);
    var route = useRoute();
    var params = ref({
      keyNo: route.query.key
    });

    function handleDownLoad(_ref) {
      var fileUrl = _ref.fileUrl;
      txtFileDownload(fileUrl);
    }

    var tableRef = ref(null);

    function getData(params) {
      var _tableRef$value;

      return (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 ? void 0 : _tableRef$value.getData(params);
    }

    function submitForm() {
      getData({
        searchKey: keywords.value
      });
    }

    return function (_ctx, _cache) {
      var _component_Search = _resolveComponent("Search");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: keywords.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return keywords.value = $event;
        }),
        placeholder: "Company name / English name"
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "btn",
            loading: subBtnLoading.value,
            onClick: submitForm
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_Search)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", null, [_createVNode(RiscernTable, {
        api: _unref(apiReportRecordList),
        params: params.value,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), function (tabItem) {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: tabItem.key,
              prop: tabItem.key,
              label: tabItem.title,
              width: tabItem.width
            }, _createSlots({
              _: 2
            }, [tabItem.htmlDomFunc ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  innerHTML: tabItem.htmlDomFunc(scope.row)
                }, null, 8, _hoisted_5)];
              })
            } : tabItem.title === 'Action' ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  class: "high-text--underline",
                  onClick: function onClick($event) {
                    return handleDownLoad(scope.row);
                  }
                }, "Download", 8, ["onClick"])];
              })
            } : undefined]), 1032, ["prop", "label", "width"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["api", "params"])])]);
    };
  }
});